import { render, staticRenderFns } from "./addInformationClassification.vue?vue&type=template&id=0d81ef92&scoped=true"
import script from "./addInformationClassification.vue?vue&type=script&lang=js"
export * from "./addInformationClassification.vue?vue&type=script&lang=js"
import style0 from "./addInformationClassification.vue?vue&type=style&index=0&id=0d81ef92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d81ef92",
  null
  
)

export default component.exports